// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codeManagement {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding: 32px 12.8px;
}

.codeLevel {
    width: 24%;
}

.codeLevelHeader {
    background-color: #323232;
    color: white;
    height: 60px;
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.codeLevelHeader p {
    margin: 0;
    text-align: left;
    padding: 4.8px 0 0 9.6px;
    height: 60%;
}

.codeLevelBtns {
    margin: 0 auto;
    width: 90%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.codeLevelBtns button {
    width: 48%;
    border: none;
    font-size: 15px;
    padding: 2px 0;
}

.deleteSelectBtn {
    background-color: #AAAAAA;
    color: white;
    padding: 0;
}

.deleteSelectBtn:hover {
    background-color: #9f9f9f;
}

.codeRegBtn {
    background-color: white;
    color: black;
    padding: 0;
}

.codeRegBtn:hover {
    background-color: #f6f6f6;
}

.codeLevelBody > .list_table {
    margin: 0 auto;
}

.codeLevelBody > .list_table th, .codeLevelBody > .list_table td {
    padding: 10px 0;
    width: auto;
}

@media screen and (max-width: 900px) {
    .codeLevelBtns button {
        font-size: 12px;
        padding: 3.2px 0 2px 0;
    }
}

@media screen and (max-width: 600px) {
    .codeManagement {
        width: 100%;
        padding: 0;
        flex-direction: column;
    }

    .codeLevel {
        width: 100%;
    }

    .codeLevelBtns {
        width: 100%;
    }

    .codeLevelBody > .list_table th, .codeLevelBody > .list_table td {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/CodeManagement.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".codeManagement {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 32px 12.8px;\n}\n\n.codeLevel {\n    width: 24%;\n}\n\n.codeLevelHeader {\n    background-color: #323232;\n    color: white;\n    height: 60px;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.codeLevelHeader p {\n    margin: 0;\n    text-align: left;\n    padding: 4.8px 0 0 9.6px;\n    height: 60%;\n}\n\n.codeLevelBtns {\n    margin: 0 auto;\n    width: 90%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.codeLevelBtns button {\n    width: 48%;\n    border: none;\n    font-size: 15px;\n    padding: 2px 0;\n}\n\n.deleteSelectBtn {\n    background-color: #AAAAAA;\n    color: white;\n    padding: 0;\n}\n\n.deleteSelectBtn:hover {\n    background-color: #9f9f9f;\n}\n\n.codeRegBtn {\n    background-color: white;\n    color: black;\n    padding: 0;\n}\n\n.codeRegBtn:hover {\n    background-color: #f6f6f6;\n}\n\n.codeLevelBody > .list_table {\n    margin: 0 auto;\n}\n\n.codeLevelBody > .list_table th, .codeLevelBody > .list_table td {\n    padding: 10px 0;\n    width: auto;\n}\n\n@media screen and (max-width: 900px) {\n    .codeLevelBtns button {\n        font-size: 12px;\n        padding: 3.2px 0 2px 0;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .codeManagement {\n        width: 100%;\n        padding: 0;\n        flex-direction: column;\n    }\n\n    .codeLevel {\n        width: 100%;\n    }\n\n    .codeLevelBtns {\n        width: 100%;\n    }\n\n    .codeLevelBody > .list_table th, .codeLevelBody > .list_table td {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
